export const AppConfig = {
  companionAppUrl: 'https://app.scrubstr.com',
}
